<template>
  <RevContainer>
    <div
      class="flex min-w-0 flex-col space-y-20 pt-60"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <!-- Assistant skeleton: left-aligned, wider, multiple lines -->
      <div class="flex min-w-0 flex-col py-10">
        <div class="w-full md:w-4/5">
          <div class="flex flex-col gap-8">
            <RevSkeleton height="16px" shape="line" width="100%" />
            <RevSkeleton height="16px" shape="line" width="60%" />
          </div>
        </div>
      </div>

      <!-- User skeleton: right-aligned, narrower, card-shaped -->
      <div class="flex min-w-0 flex-col py-10">
        <RevCard
          class="!bg-static-default-mid w-4/5 self-end whitespace-pre-line px-16 py-12 shadow-none md:w-3/5 !rounded-br-sm"
        >
          <div class="flex flex-col gap-8">
            <RevSkeleton height="16px" shape="line" width="100%" />
            <RevSkeleton height="16px" shape="line" width="70%" />
          </div>
        </RevCard>
      </div>

      <!-- Assistant skeleton: left-aligned, wider, multiple lines -->
      <div class="flex min-w-0 flex-col py-10">
        <div class="w-full md:w-4/5">
          <div class="flex flex-col gap-8">
            <RevSkeleton height="16px" shape="line" width="100%" />
            <RevSkeleton height="16px" shape="line" width="88%" />
          </div>
        </div>
      </div>

      <span class="sr-only">{{ i18n(translations.loadingConversation) }}</span>
    </div>
  </RevContainer>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevContainer } from '@ds/components/Container'
import { RevSkeleton } from '@ds/components/Skeleton'

import translations from './LoadingConversationSkeleton.translations'

const i18n = useI18n()
</script>
